module.exports = __webpack_public_path__ + "c974cb190ee20dbb35b0c6c62d2a6221.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Hero/images/zoom-pavillion.gif
 ** module id = 377
 ** module chunks = 0
 **/